import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { ManagedByIwocaPill } from 'components/ManagedByIwocaPill/ManagedByIwocaPill';
import { useLocale } from 'hooks/useLocale';
import styles from './CreatedCell.module.css';

export const CreatedCell = ({
  value,
  data,
}: Pick<ICellRendererParams, 'value' | 'data'>) => {
  const { i18n } = useLocale();

  const createdDate = i18n.date(value, {
    day: '2-digit',
    month: 'short',
    year: '2-digit',
  });

  const isPartnerChannel = data.is_partner_channel;

  return (
    <div>
      <div>{createdDate}</div>
      {isPartnerChannel && (
        <div className={styles.managedByIwocaPill}>
          <ManagedByIwocaPill size="small" />
        </div>
      )}
    </div>
  );
};
